import React from "react";

// Customizable Area Start
import {
  Box,
  Button,
} from "@mui/material";
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";

interface ISort {
  label: string
  value: string
}
// Customizable Area End
import SortingController, { Props, configJSON } from "./SortingController";
import { Catalogue } from "./model/Catalogue";

// Customizable Area Start
const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          width: "180px",
          height: "48px",
          fontFamily: "Montserrat",
          fontWeight: 500,
          fontSize: "14px",
          lineHeight: "22px",
          color: "#0F172A", // Text color
          justifyContent: "left",
          border: "1px solid #CBD5E1",
          borderRadius: "8px", // Rounded corners
          textTransform: "none", // Prevents uppercase text
          padding: "10px 12px 10px 16px",
          "&:hover": {
              border: "1px solid #CBD5E1",
            },
        },
      },
    },
  },
});
// Customizable Area End

export default class Sorting extends SortingController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    return (
      //Merge Engine DefaultContainer
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          {/* Customizable Area Start */}
          <Box sx={{ display: "flex", gap: "10px", flexWrap: "wrap"}} mb={2}>
            {configJSON.SORT_LISTS.map((sort: ISort) => {
              const { label, value } = sort
              return (
                <Button
                  key={value}
                  data-test-id="sortBtn"
                  variant="outlined"
                  onClick={() => this.props.handleSortChange(label, value)}
                >
                  {label}
                </Button>
              )
            })}
          </Box>
          {/* Customizable Area End */}
        </ThemeProvider>
      </StyledEngineProvider>
      //Merge Engine End DefaultContainer
    );
  }
}

// Customizable Area Start
// Customizable Area End
